import { Box, Button, Grid } from '@mui/material';
import { useApp } from '../../Contexts/AppProvider';

const Home: React.FC = () => {
  const {disabledButtons, onSetStep, activeStep, config} = useApp();

  return activeStep !== undefined ? (
    <>
      <Grid container spacing={2}>
        {config?.assets?.cards?.map((card, index) => (
          <Grid key={index+'-home-cards'} item xl={12} lg={12} md={12} xs={12}>
            <img
              alt={card?.name}
              src={`${card?.src}`}
              style={{width: '100%'}}
            />
          </Grid>
        ))}
      </Grid>

      <Box sx={{display: 'flex', justifyContent: 'space-between', mt: 5}}>  
        <Box />
      
        <Button
          id='btnNext'
          disabled={disabledButtons}
          variant="contained"
          onClick={() => onSetStep(activeStep+1)}
        >
          Próximo
        </Button>  
      </Box>
    </>
  ) : <></>;
}

export default Home;